// extracted by mini-css-extract-plugin
module.exports = {"bundleHeading":"BundleHeaderPageSegment-BundleHeading-module--bundle-heading--1aslX"};